import styled from 'styled-components';

import { basicTitleTextStyle, fonts, Link } from '@dreryk/react-components';

export const StyledLink = styled(Link)`
   ${basicTitleTextStyle};
   font-weight: ${fonts.fontWeightBold};
`;

StyledLink.displayName = 'StyledLink';
